import React from 'react';
import PropTypes from 'prop-types';
import 'regenerator-runtime';

import AsyncSelect from '@thesharpieone/react-select-async-pagination/lib/Async';

export default class ResourceSelect extends React.Component {

	static propTypes = {
    resource: PropTypes.string.isRequired,
		isMulti: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		isMulti: true,
	};

  fieldToSelect(field) {
    const { isMulti } = this.props;

    switch(isMulti) {
      case false:
        return field.value ? this.docToOption(field.value) : field.value;
      default:
      case true:
        return field.value ? field.value.map(this.docToOption) : [];
    }
  }

  handleChange(selectValue) {
  	var { form, field, isMulti } = this.props;
    var fieldValue;

    // unpack docs from selected option(s)
    if(selectValue !== null) {
      fieldValue = isMulti
        ? selectValue.map(v => v.doc)
        : selectValue.doc;
    } else {
      fieldValue = '';
    }

  	form.setFieldValue(field.name, fieldValue);
  }

  docToOption(doc) {
    return {
      label: doc.label,
      value: doc._id,
      doc: doc,
    }
  }

  // 	return options;
  async loadOptions(inputValue, page) {
    let queryString = `page=${page}&sortBy=name&sortDir=asc`;

    if (inputValue.length) {
      queryString += `&search=${inputValue}`;
    }

    const data = await fetch(`/api/${this.props.resource}?${queryString}`).then(res => res.json())
    let { docs = [] } = data;

    if (this.props.filter) {
      docs = docs.filter(this.props.filter);
    }

    return docs.map(this.docToOption);
  }

  render() {
  	var {
  		field,
  		isMulti
  	} = this.props;

    return (
      <AsyncSelect
        className="Select"
        value={this.fieldToSelect(field)}
    		onChange={::this.handleChange}
      	isMulti={isMulti}
      	cacheOptions
      	defaultOptions
      	pagination
      	loadOptions={::this.loadOptions}
      />
    );
  }

}



// WEBPACK FOOTER //
// ./src/modules/form/components/input/ResourceSelect.jsx